module.exports = __webpack_public_path__ + "img/2.5e8cb230.png";